import { useMemo } from "react";
import type { SessionUser } from "@majourneys/booking";
import { useSession } from "../../../lib/auth";
import { useMyProfile } from "./use-my-profile";

/**
 * Who is booking, for the booking forms to fill in (owner, 2026-09-26: a
 * signed-in guest must not retype their name and email).
 *
 * The profile's first and last name win over the session `name`, which
 * better-auth fills with the email on sign-ups that gave no name. The account
 * holds no phone, so the form still asks for that. Undefined when signed out.
 */
export function useBookingSessionUser(): SessionUser | undefined {
  const { data: session } = useSession();
  const user = session?.user;
  const { data: profile } = useMyProfile({ enabled: !!user });
  const profileName = [profile?.user.firstName?.trim(), profile?.user.lastName?.trim()]
    .filter(Boolean)
    .join(" ");
  const name = profileName || user?.name;
  const email = user?.email;
  return useMemo(() => (user ? { name, email } : undefined), [user, name, email]);
}
